<script lang="ts">
    import KpLoansGenericTable from './KpLoansGenericTable.svelte';
    import type {Loan} from 'typings/portaro.be.types';
    import {getDateFormatter, getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import LoanDocument from './LoanDocument.svelte';
    import {fade} from 'svelte/transition';
    import type {PageableList, PageableListState} from 'shared/utils/reactive-pageable-list';
    import type {EmptyObject} from 'typings/portaro.fe.types';
    import type {Observable} from 'rxjs';

    export let loanList: PageableList<Loan, string, EmptyObject>;
    export let canLoanCancelAny: boolean;
    export let cancelLoan: (loan: Loan) => void;

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();

    let loanListData: Observable<PageableListState<Loan, string, EmptyObject>>;
    $: loanListData = loanList.getState$();
</script>

<KpLoansGenericTable {loanList}>
    <tr slot="header">
        <th class="header-document-name">{localize(/* @kp-localization commons.nazevDokumentu */ 'commons.nazevDokumentu')}</th>
        <th class="header-location">{localize(/* @kp-localization exemplar.location */ 'exemplar.location')}</th>
        <th class="header-reservation-date">{localize(/* @kp-localization loan.DatumRezervace */ 'loan.DatumRezervace')}</th>
        <th class="header-reservation-deadline-date">{localize(/* @kp-localization loan.CekatDo */ 'loan.CekatDo')}</th>
        <th class="header-reservation-state">{localize(/* @kp-localization commons.stav */ 'commons.stav')}</th>

        {#if canLoanCancelAny}
            <th class="header-reservation-cancelling">{localize(/* @kp-localization commons.zrusit */ 'commons.zrusit')}</th>
        {/if}
    </tr>

    <svelte:fragment slot="body">
        {#each $loanListData.loadedItems ?? [] as loan(loan.id)}
            <tr class="loan-item" in:fade>
                <td class="data-document-name">
                    <LoanDocument loan="{loan}"/>
                </td>

                <td class="data-location centered-loan-data">
                    {#if loan.location}
                        {loan.location.text}
                    {/if}
                </td>

                <td class="data-reservation-date centered-loan-data">{pipe(loan.reservationDate, dateFormatter('d.M.yyyy'))}</td>

                <td class="data-reservation-deadline-date centered-loan-data">
                    {#if loan.reservationDeadlineDate}
                        {pipe(loan.reservationDeadlineDate, dateFormatter('d.M.yyyy'))}
                    {/if}
                </td>

                <td class="data-reservation-state centered-loan-data">
                    <IconedContent icon="info" orientation="vertical">
                        {loan.stateText}
                    </IconedContent>
                </td>
                {#if canLoanCancelAny}
                    <td class="data-reservation-cancelling centered-loan-data">
                        <KpButton buttonSize="sm"
                                  on:click={() => cancelLoan(loan)}
                                  dataQa="cancel-waiting-loan-button">

                            <IconedContent icon="cross-circle">
                                {localize(/* @kp-localization commons.zrusit */ 'commons.zrusit')}
                            </IconedContent>
                        </KpButton>
                    </td>
                {/if}
            </tr>
        {/each}
    </svelte:fragment>
</KpLoansGenericTable>